/**
 * Corps servi par le serveur, gardé pour le cas où l'API ne répond pas (11/10/2026).
 *
 * Audit Google du 10/10/2026 : `seo-inject.js` place dans #root le vrai titre, le
 * texte et les liens de la page (<article class="gively-ssr">). React (createRoot)
 * remplace ce contenu au montage. Quand l'appel à l'API échoue ensuite — panne,
 * réseau mobile, ou robot qui ne peut pas joindre api.gively.fr —, la fiche
 * association redirigeait vers l'annuaire : mesuré dans Chromium avec l'API
 * bloquée, 1 172 caractères de texte tombaient à 54 et le titre disparaissait.
 * Google indexe le HTML RENDU (« Google also uses the rendered HTML to index the
 * page », developers.google.com/search/docs/crawling-indexing/javascript/
 * javascript-seo-basics, page du 2026-03-04).
 *
 * Ce module lit ce corps UNE fois, juste avant le montage (index.js), en texte :
 * titre, paragraphes et intertitres, liens internes. Rien n'est réinjecté en HTML ;
 * la page qui l'utilise le rend avec des éléments React. La capture n'est rendue
 * que pour le chemin où elle a été faite : après une navigation interne, elle ne
 * correspond plus à rien et reste muette.
 */
const BASE = "https://www.gively.fr";
let capture = null;

export function capturerCorpsServeur(doc = document, loc = window.location) {
  capture = null;
  try {
    const article = doc.querySelector("#root article.gively-ssr");
    const h1 = (article?.querySelector("h1")?.textContent || "").trim();
    if (!h1) return null;
    const blocs = [...article.querySelectorAll("h2, h3, p")]
      .map((el) => ({ type: el.tagName.toLowerCase(), texte: (el.textContent || "").trim() }))
      .filter((b) => b.texte)
      .slice(0, 40);
    const liens = [...article.querySelectorAll("a[href]")]
      .map((a) => ({ href: a.getAttribute("href") || "", texte: (a.textContent || "").trim() }))
      .filter((l) => l.texte && l.href.startsWith(`${BASE}/`))
      .map((l) => ({ chemin: l.href.slice(BASE.length) || "/", texte: l.texte }))
      .slice(0, 30);
    capture = { chemin: loc.pathname, h1, blocs, liens };
  } catch (_) {
    capture = null;
  }
  return capture;
}

/** Le corps capturé si l'on est encore sur la page où il a été servi, sinon null. */
export function corpsServeur(chemin) {
  return capture && capture.chemin === chemin ? capture : null;
}
